export default __webpack_public_path__ + "static/media/8h.bb4c4be6.png";